import { render, staticRenderFns } from "./MajorChooseSingle.vue?vue&type=template&id=de55bf40&scoped=true"
import script from "./MajorChooseSingle.vue?vue&type=script&lang=js"
export * from "./MajorChooseSingle.vue?vue&type=script&lang=js"
import style0 from "./MajorChooseSingle.vue?vue&type=style&index=0&id=de55bf40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de55bf40",
  null
  
)

export default component.exports